// import React, { useEffect, useState } from "react";
// import api from "../../api/axios";
// import UploadFileModal from "./UploadFileModal";

// const DownloadSection = () => {
//   const [files, setFiles] = useState([]);
//   const [showModal, setShowModal] = useState(false);

//   const fetchFiles = async () => {
//     const res = await api.get("companyblog/admin/uploads/", {
//       headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//     });
//     setFiles(res.data);
//   };

//   useEffect(() => {
//     fetchFiles();
//   }, []);

//   const deleteFile = async (id) => {
//     if (!window.confirm("Delete this file permanently?")) return;

//     await api.delete(`companyblog/admin/uploads/${id}/`, {
//       headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//     });

//     fetchFiles();
//   };

//   return (
//     <div className="admin-card">
//       {/* HEADER */}
//       <div className="admin-header">
//         <h2>Upload Files</h2>
//         <button className="btn-primary" onClick={() => setShowModal(true)}>
//           ADD FILES
//         </button>
//       </div>

//       {/* TABLE */}
//       <table className="admin-table">
//         <thead>
//           <tr>
//             <th>Filename</th>
//             <th>Type</th>
//             <th>File / Link</th>
//             <th>Uploaded At</th>
//             <th>Action</th>
//           </tr>
//         </thead>

//         <tbody>
//           {files.map((item) => (
//             <tr key={item.id}>
//               <td>{item.filename}</td>
//               <td>{item.file_type.toUpperCase()}</td>
//               <td>
//                 {item.file_url ? (
//                   <a href={item.file_url} target="_blank" rel="noreferrer">
//                     Download
//                   </a>
//                 ) : (
//                   <a href={item.link} target="_blank" rel="noreferrer">
//                     Open Link
//                   </a>
//                 )}
//               </td>
//               <td>{new Date(item.created_at).toLocaleString()}</td>
//               <td>
//                 <button
//                   className="btn-danger"
//                   onClick={() => deleteFile(item.id)}
//                 >
//                   DELETE
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {showModal && (
//         <UploadFileModal
//           onClose={() => setShowModal(false)}
//           onSuccess={fetchFiles}
//         />
//       )}
//     </div>
//   );
// };

// export default DownloadSection;

import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import UploadFileModal from "./UploadFileModal";

const DownloadSection = () => {
  const [files, setFiles] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchFiles = async () => {
    const res = await api.get("companyblog/admin/uploads/", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    setFiles(res.data);
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const deleteFile = async (id) => {
    if (!window.confirm("Delete this file permanently?")) return;

    await api.delete(`companyblog/admin/uploads/${id}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    fetchFiles();
  };

  return (
    <>
      {/* ===== PAGE CSS (INLINE) ===== */}
      <style>
        {`
        .admin-card {
          background: #fff;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
        }

        .admin-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: linear-gradient(90deg, #5b5fd6, #7b7ff7);
          padding: 16px 20px;
          border-radius: 6px;
          color: #fff;
          margin-bottom: 20px;
        }

        .admin-header h2 {
          margin: 0;
          font-size: 20px;
        }

        .btn-primary {
          background: #2d6cff;
          color: #fff;
          border: none;
          padding: 8px 16px;
          font-weight: 600;
          border-radius: 4px;
          cursor: pointer;
        }

        .btn-primary:hover {
          background: #1e56d8;
        }

        .btn-danger {
          background: #e63946;
          color: #fff;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
        }

        .btn-danger:hover {
          background: #c92c37;
        }

        .admin-table {
          width: 100%;
          border-collapse: collapse;
        }

        .admin-table th {
          text-align: left;
          padding: 10px;
          border-bottom: 2px solid #ddd;
          font-weight: 600;
        }

        .admin-table td {
          padding: 12px 10px;
          border-bottom: 1px solid #eee;
        }

        .admin-table tr:hover {
          background: #fafafa;
        }

        .admin-table a {
          color: #2d6cff;
          font-weight: 500;
          text-decoration: none;
        }
      `}
      </style>

      <div className="admin-card">
        {/* HEADER */}
        <div className="admin-header">
          <h2>Upload Files</h2>
          <button className="btn-primary" onClick={() => setShowModal(true)}>
            ADD FILES
          </button>
        </div>

        {/* TABLE */}
        <table className="admin-table">
          <thead>
            <tr>
              <th>Filename</th>
              <th>Type</th>
              <th>File / Link</th>
              <th>Uploaded At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {files.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No files uploaded
                </td>
              </tr>
            ) : (
              files.map((item) => (
                <tr key={item.id}>
                  <td>{item.filename}</td>
                  <td>{item.file_type.toUpperCase()}</td>
                  <td>
                    {item.file_url ? (
                      <a href={item.file_url} target="_blank" rel="noreferrer">
                        Download
                      </a>
                    ) : (
                      <a href={item.link} target="_blank" rel="noreferrer">
                        Open Link
                      </a>
                    )}
                  </td>
                  <td>{new Date(item.created_at).toLocaleString()}</td>
                  <td>
                    <button
                      className="btn-danger"
                      onClick={() => deleteFile(item.id)}
                    >
                      DELETE
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {showModal && (
          <UploadFileModal
            onClose={() => setShowModal(false)}
            onSuccess={fetchFiles}
          />
        )}
      </div>
    </>
  );
};

export default DownloadSection;
